// ─── CURSOR LOGIC ─────────────────────────────────────────
const cursor = document.getElementById('cursor');
const ring = document.getElementById('cursorRing');
let mx = 0, my = 0, rx = 0, ry = 0;

if (cursor) {
  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    window.requestAnimationFrame(() => {
      cursor.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
    });
  }, { passive: true });

  if (ring) {
    (function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      requestAnimationFrame(animRing);
    })();
  }

  document.addEventListener('mouseover', e => {
    if (e.target.closest('a, button, .color-swatch, .product-thumb, .qty-btn, .size-btn')) {
      cursor.classList.add('cursor--hover');
      if (ring) ring.classList.add('cursor-ring--hover');
    }
  });

  document.addEventListener('mouseout', e => {
    if (e.target.closest('a, button, .color-swatch, .product-thumb, .qty-btn, .size-btn')) {
      cursor.classList.remove('cursor--hover');
      if (ring) ring.classList.remove('cursor-ring--hover');
    }
  });
}

// ─── CART DRAWER ──────────────────────────────────────────
let cartIsOpen = false;

function openCart() {
  cartIsOpen = true;
  document.getElementById('cartOverlay')?.classList.add('open');
  document.getElementById('cartDrawer')?.classList.add('open');
  refreshCart();
}

function closeCart() {
  cartIsOpen = false;
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.getElementById('cartDrawer')?.classList.remove('open');
}

function toggleCart() {
  cartIsOpen ? closeCart() : openCart();
}

document.addEventListener('click', e => {
  if (e.target.closest('#cartToggle')) toggleCart();
  if (e.target.closest('#cartClose')) closeCart();
  if (e.target.closest('#cartOverlay')) closeCart();
});

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

function refreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const countEl = document.getElementById('cartCount');
      if (countEl) countEl.textContent = cart.item_count;

      const itemsEl = document.getElementById('cartItems');
      const totalEl = document.getElementById('cartTotal');
      const empty = document.getElementById('cartEmpty');
      const wrapper = document.getElementById('cartItemsWrapper');

      if (cart.item_count === 0) {
        if (empty) empty.style.display = 'flex';
        if (wrapper) wrapper.style.display = 'none';
        return;
      }

      if (empty) empty.style.display = 'none';
      if (wrapper) wrapper.style.display = 'flex';

      if (itemsEl) {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <div class="cart-item-image">
              ${item.image ? `<img src="${item.image}" alt="${item.product_title}" width="80" />` : ''}
            </div>
            <div>
              <div class="cart-item-name">${item.product_title}</div>
              <div class="cart-item-meta">${item.variant_title || ''}</div>
              <div class="cart-item-controls">
                <div class="qty-control">
                  <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
                  <span class="qty-val">${item.quantity}</span>
                  <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
              </div>
            </div>
          </div>
        `).join('');
      }
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    });
}

function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(() => refreshCart());
}

// ─── THE 404 KILLER (AJAX ADD TO BAG) ─────────────────────
document.addEventListener('submit', function(e) {
  const form = e.target;
  
  if (form.hasAttribute('data-ajax-form') || form.action.includes('/cart/add')) {
    e.preventDefault();
    const formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add');
      return response.json();
    })
    .then(item => {
      refreshCart();
      openCart();
    })
    .catch(error => {
      console.error('AJAX Error:', error);
      window.location.href = '/cart';
    });
  }
});

// ─── COLLECTION FILTERS ───────────────────────────────────
document.addEventListener('click', e => {
  const btn = e.target.closest('.filter-btn');
  if (!btn) return;
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const filter = btn.dataset.filter;
  document.querySelectorAll('.collection-product-card').forEach(card => {
    if (filter === 'all') {
      card.style.display = '';
    } else {
      const tags = (card.dataset.tags || '').split(',');
      card.style.display = tags.includes(filter) ? '' : 'none';
    }
  });
});

// ─── NOTHING FITS SYSTEM LOGIC ─────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  refreshCart();

  // 1. ARCHIVE REDIRECT (From Register/Login)
  if (window.location.pathname === '/account' && (document.referrer.includes('/account/register') || document.referrer.includes('/account/login'))) {
    window.location.href = '/pages/archive';
  }
  
  if (window.location.search.includes('customer_posted=true')) {
    window.location.href = '/pages/archive';
  }

  // 2. ACCOUNT PAGE ESCAPE HATCH (Floating Home Button)
  (function() {
    if (window.location.pathname.includes('/account')) {
      if (document.getElementById('manual-home-button')) return;

      const backButton = document.createElement('a');
      backButton.id = 'manual-home-button';
      backButton.href = '/';
      backButton.innerHTML = '← RETURN TO HUB';
      backButton.style.cssText = `
        position: fixed;
        top: 30px;
        left: 30px;
        z-index: 9999999;
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        letter-spacing: 0.2em;
        color: #8a8880;
        text-decoration: none;
        text-transform: uppercase;
        padding: 10px;
        background: rgba(245, 244, 240, 0.9);
        backdrop-filter: blur(4px);
        transition: color 0.3s ease;
      `;
      
      backButton.onmouseover = () => { backButton.style.color = '#000'; };
      backButton.onmouseout = () => { backButton.style.color = '#8a8880'; };
      document.body.appendChild(backButton);
    }
  })();
});
